import * as Sentry from "@sentry/react";
import {
    SENTRY_DSN,
    SENTRY_ENABLED,
    SENTRY_ENVIRONMENT,
    SENTRY_RELEASE,
    SENTRY_TRACES_SAMPLE_RATE,
    SENTRY_REPLAY_SESSION_SAMPLE_RATE,
    SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE,
} from "configs/sentry.config";

/**
 * Initialize Sentry SDK
 * Must be called before React renders
 */
export function initSentry() {
    if (!SENTRY_ENABLED) {
        console.info("[Sentry] Disabled - no DSN configured");
        return;
    }

    Sentry.init({
        dsn: SENTRY_DSN,
        environment: SENTRY_ENVIRONMENT,
        release: SENTRY_RELEASE,

        // Send default PII data (IP, user info if available)
        sendDefaultPii: true,

        // Performance Monitoring
        tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,

        // Session Replay
        replaysSessionSampleRate: SENTRY_REPLAY_SESSION_SAMPLE_RATE,
        replaysOnErrorSampleRate: SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE,

        integrations: [
            // Browser tracing for performance
            Sentry.browserTracingIntegration(),
            // Session replay for debugging user actions before errors
            Sentry.replayIntegration({
                maskAllText: true, // Privacy: mask text content
                blockAllMedia: true, // Privacy: block media content
            }),
        ],

        // Sanitize sensitive data before sending
        beforeSend(event) {
            // Remove authorization headers from breadcrumbs
            if (event.breadcrumbs) {
                event.breadcrumbs = event.breadcrumbs.map(breadcrumb => {
                    if (breadcrumb.data?.headers) {
                        const safeHeaders = { ...breadcrumb.data.headers };
                        delete safeHeaders.Authorization;
                        delete safeHeaders.authorization;
                        delete safeHeaders['X-API-KEY'];
                        delete safeHeaders['SECRET-KEY'];
                        breadcrumb.data.headers = safeHeaders;
                    }
                    return breadcrumb;
                });
            }
            return event;
        },

        // Enable in all environments (controlled by DSN presence)
        enabled: SENTRY_ENABLED,
    });

    console.info(`[Sentry] Initialized (${SENTRY_ENVIRONMENT})`);
}

// Re-export Sentry for use elsewhere in the application
export { Sentry };
